module.exports = __webpack_public_path__ + "img/swf.fb543d4c.png";